import React, { useEffect, useRef, Suspense, useMemo } from "react";
import { Canvas, extend, useThree, useLoader, useFrame } from '@react-three/fiber'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { Center, Float, Text3D, GradientTexture, } from "@react-three/drei";
import { useState } from "react";
import { loadGltf } from "../../functions/LoadGltfHelper";
import * as THREE from 'three'
extend({ TextGeometry, OrbitControls })


export default function ObjectCover(props) {

    return (
        <Canvas
            // frameloop='demand'
            gl2={true}
            gl={{ antialias: true, alpha: false }}
            onCreated={({ gl }) => {
                gl.setPixelRatio(window.devicePixelRatio);
                gl.domElement.style.borderTopLeftRadius = '5px'
                gl.domElement.style.borderTopRightRadius = '5px'
            }}
            camera={{position:[0,0,-500], far:1000, near:0.5, fov:90}}
        >
            <ambientLight intensity={0.5} />
            <directionalLight intensity={1} />
            <color attach="background" args={['white']} />
            <Scene
                {...props}
            />
        </Canvas>

    )
}


function Scene(props) {
    const { camera, gl, invalidate, scene } = useThree()
    const orbit = useRef()


    const [gltf, setGltf] = useState(null)
    useEffect(() => {
        if (gl)
        handleModel()
    }, [gl])
    const handleModel = async () => {
        let model = await loadGltf(props.url, gl)
        model.scene.traverse(node=>{
            if (node.isMesh) {
                let material = node.material;
                let newMaterial = new THREE.MeshToonMaterial();
                newMaterial.color = material.color
                newMaterial.map = material.map
                node.material = newMaterial;
                newMaterial.dispose();
        
                if (node?.material?.map) {
                  node.material.map.encoding = THREE.sRGBEncoding
                  node.material.needsUpdate = true;
                  if (node.material.emissiveMap)
                    node.material.emissiveMap.encoding = THREE.sRGBEncoding;
                }
        
                node.castShadow = true;
                node.receiveShadow = true;
                node.needsUpdate = true
                node.matrixAutoUpdate = false
                node.matrixWorldNeedsUpdate = false
                node.updateMatrixWorld()
                node.updateMatrix()    
              }
        })
        model.scene.scale.set(0.5,0.5,0.5)
        model.scene.rotation.y =Math.PI
        setGltf(model)
    }
    // useEffect(() => {
    //     if (orbit.current) {
    //         orbit.current.enableDamping = true
    //         // orbit.current.enableDamping = true
    //         orbit.current.addEventListener('start', handleOrbitStart);
    //         orbit.current.addEventListener('changed', handleOrbitEnd);
    //         orbit.current.addEventListener('change', handleOrbitChange);
    //         return () => {
    //             if (orbit.current) {
    //                 orbit.current.removeEventListener('start', handleOrbitStart);
    //                 orbit.current.removeEventListener('changed', handleOrbitEnd);
    //                 orbit.current.removeEventListener('change', handleOrbitChange);
    //             }
    //         };
    //     }
    // }, [orbit.current])

    // const handleOrbitChange = () => {
    //     invalidate()
    // }
    // const handleOrbitStart = () => {
    //     invalidate()
    // }
    // const handleOrbitEnd = () => {
    //     invalidate()
    // }

    return (
        <>
            <Suspense fallback={null
            }>
                {/* <mesh position={[0, 0, 0]} >
                    <textGeometry attach='geometry' args={['2321312', config]} />
                    <meshBasicMaterial attach='material' color={'red'} />
                </mesh> */}
                <Center>
                    <Float floatIntensity={5} speed={2}>
                        <mesh position={[0,0,-10]} >
                            {gltf && <primitive object={gltf.scene} />}
                        </mesh>
                    </Float>

                </Center>

            </Suspense>
            <orbitControls ref={orbit} args={[camera, gl.domElement]} />
        </>
    )
}


